import React, { useState, useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import {
  Menu,
  User,
  Lock,
  LogOut,
  Home,
  Calendar,
  Edit
} from "lucide-react";
import useMembreAuth from "../../hooks/useMembreAuth";

export default function MembreLayout() {
  const { user, loading } = useMembreAuth();
  const location = useLocation();

  const [open, setOpen] = useState(false);


  

  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-600">
        Chargement…
      </div>
    );
  }

  
  if (!user) {
    window.location.href = "/membre/login";
    return null;
  }

  
  const points = user?.points || 0;
  const level = user?.level || "Bronze";

  
  const menu = [
    { name: "Dashboard", href: "/membre/dashboard", icon: <Home size={18} /> },
    { name: "Mon Profil", href: "/membre/profile", icon: <User size={18} /> },
    { name: "Modifier mes infos", href: "/membre/edit-profile", icon: <Edit size={18} /> },
    { name: "Historique", href: "/membre/history", icon: <Calendar size={18} /> },
    { name: "Mot de passe", href: "/membre/change-password", icon: <Lock size={18} /> },
  ];

  function logout() {
    localStorage.removeItem("membreToken");
    window.location.href = "/";
  }

  
  return (
    <div className="flex min-h-screen bg-gray-100 text-slate-900">

      
      <aside className="hidden md:flex fixed left-0 top-0 h-screen w-64 bg-white shadow-xl p-6 z-40 flex-col border-r">

        
        <div className="flex flex-col items-center gap-2 mb-6">
          <img src="/images/aleoa.jpg" className="w-14 h-14 rounded-full shadow" />
          <h2 className="text-lg font-bold text-blue-700">Espace Membre</h2>
        </div>

        
        <div className="flex items-center gap-3 mb-6 p-3 bg-gray-50 rounded-xl">
          <img src={user.avatar || "/images/default-avatar.png"}
           className="w-10 h-10 rounded-full border shadow" />
          <div className="overflow-hidden">
            <p className="font-semibold text-sm truncate">
              {user.prenom.toUpperCase()}
            </p>

            <span
              className={`inline-block mt-1 text-xs px-2 py-1 rounded-full font-semibold
              ${level === "Elite"
                  ? "bg-purple-600 text-white"
                  : level === "Gold"
                    ? "bg-yellow-500 text-white"
                    : level === "Silver"
                      ? "bg-gray-400 text-white"
                      : "bg-amber-700 text-white"
                }`}
            >
              {level}
            </span>

            <p className="text-xs text-gray-500 truncate mt-1">
              {user.email}
            </p>
          </div>
        </div>

        
        <nav className="flex flex-col gap-2 flex-1 overflow-y-auto pr-2">
          {menu.map((item, i) => (
            <Link
              key={i}
              to={item.href}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm transition
                ${location.pathname === item.href
                  ? "bg-blue-600 text-white font-semibold"
                  : "hover:bg-gray-200"
                }`}
            >
              {item.icon}
              {item.name}
            </Link>
          ))}
        </nav>

        
        <div className="pt-4 border-t mt-4 space-y-3">

          <Link
            to="/"
            className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 py-2 rounded-lg flex items-center justify-center gap-2 text-sm font-medium transition"
          >
            <Home size={16} />
            Retour au site
          </Link>

          <button
            onClick={logout}
            className="w-full bg-red-600 hover:bg-red-700 text-white py-2 rounded-lg flex items-center justify-center gap-2 text-sm font-medium transition"
          >
            <LogOut size={16} />
            Déconnexion
          </button>

        </div>
      </aside>

      
      <header className="md:hidden fixed top-0 left-0 w-full bg-white shadow p-4 flex items-center justify-between z-50">
        <button onClick={() => setOpen(true)}>
          <Menu size={28} />
        </button>

        <div className="flex items-center gap-2">
          <img
            src="/images/aleoa.jpg"
            alt="Logo Association"
            className="w-8 h-8 rounded-full"
          />
          <span className="text-sm font-bold text-blue-700">
            ALEOA
          </span>
        </div>

        <img
          src={user.avatar || "/images/default-avatar.png"}
          className="w-9 h-9 rounded-full border"
        />
      </header>

      
      {open && (
        <>
          <div
            className="fixed inset-0 bg-black/40 z-40 md:hidden"
            onClick={() => setOpen(false)}
          />

          <aside className="fixed top-0 left-0 w-72 h-full bg-white z-50 p-6 shadow-2xl md:hidden flex flex-col">

            <div className="flex items-center justify-between mb-6">
              <h2 className="font-bold text-blue-700">
                Espace Membre
              </h2>
              <button onClick={() => setOpen(false)}>✕</button>
            </div>

            <div className="flex items-center gap-3 mb-6">
              <img src={user.avatar || "/images/default-avatar.png"} className="w-12 h-12 rounded-full border shadow" />
              <div>
                <p className="font-semibold">{user.prenom.toUpperCase()}</p>
                 <span
              className={`inline-block mt-1 text-xs px-2 py-1 rounded-full font-semibold
              ${level === "Elite"
                  ? "bg-purple-600 text-white"
                  : level === "Gold"
                    ? "bg-yellow-500 text-white"
                    : level === "Silver"
                      ? "bg-gray-400 text-white"
                      : "bg-amber-700 text-white"
                }`}
            >
              {level}
            </span>
                <p className="text-xs opacity-70">{user.email}</p>
              </div>
            </div>

            <nav className="flex flex-col gap-2 flex-1">
              {menu.map((item, i) => (
                <Link
                  key={i}
                  to={item.href}
                  onClick={() => setOpen(false)}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm transition
                    ${location.pathname === item.href
                      ? "bg-blue-600 text-white font-semibold"
                      : "hover:bg-gray-200"
                    }`}
                >
                  {item.icon}
                  {item.name}
                </Link>
              ))}
            </nav>

            <Link
              to="/"
              onClick={() => setOpen(false)}
              className="mb-3 bg-gray-200 hover:bg-gray-300 py-2 rounded-lg flex items-center justify-center gap-2 text-sm font-medium transition"
            >
              <Home size={16} />
              Retour au site
            </Link>

            <button
              onClick={logout}
              className="bg-red-600 text-white py-2 rounded-lg flex items-center justify-center gap-2"
            >
              <LogOut size={16} />
              Déconnexion
            </button>
          </aside>
        </>
      )}

      
      <main className="flex-1 w-full pt-20 md:pt-0 p-4 md:p-8 md:ml-64">
        <Outlet />
      </main>

    </div>
  );
}
